import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors } from '../Globals/styles';
import '../../Content/Javascript/sly';

class TimeWheelInput extends Component {
  constructor(props) {
    super(props);
    this.sly = null;
  }
  componentDidUpdate = (prevProps) => {
    if (prevProps.value!==this.props.value){
      this.sly.activate(this.props.value)
    }
  };
  componentDidMount = () => {
    this.slySetup();
  };
  slySetup = () => {
    const { value } = this.props;
    var options = {
      //main
      horizontal: true,
      //navigation
      itemNav: 'forceCentered',
      activateMiddle: true,
      activateOn: 'click',
      smart: true,
      //scroll
      scrollBy: 0,
      //dragging
      mouseDragging: true,
      touchDragging: true,
      releaseSwing: true,
      interactive: true,
      elasticBounds: true,
      // Mixed options
      speed: 300
    };
    // eslint-disable-next-line 
    this.sly = new Sly(this.refs.frame, options, {
      moveEnd: this.onChangeHandler
    });
    this.sly.init();
    //set active item according to default value
    this.sly.activate(value, true)
  };
  onChangeHandler = () => {
    const { onChange } = this.props;
    var newSelected = parseFloat(this.sly.rel.activeItem);

    // if new selected is the same as the old return and do nothing
    if (newSelected===this.props.value) return;
    onChange(newSelected)
  };
  componentWillUnmount =() => {
    this.sly.destroy();
  };
  renderItems = () => {
    var items = [];
    for (var i = 0; i <= 24; i++) {
      items.push((<li key={i} style={[styles.item, this.props.value===i && styles.active]}>{i}:00</li>))
    }
    return items;
  };
  render() {
    return (
      <div style={styles.frame} ref="frame">
        <ul style={[styles.slidee, this.props.ulStyles]} className="slidee">
          {this.renderItems()}
        </ul>
        <div style={styles.middleMarker}></div>
        <div style={[styles.overlay, this.props.overLayColor && {background: this.props.overLayColor}]}> </div>
      </div>
    );
  }
}

var styles = {
  frame: {
    zIndex: '9',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    position: 'relative',
    cursor: 'pointer',
    lineHeight: '40px'
  },
  slidee: {
    margin: '0',
    padding: '0',
    height: '100%',
    listStyle: 'none',
    color: semanticColors.text
  },
  middleMarker: {
    width: '50px',
    height: '80%',
    marginTop: '2%',
    borderLeft: "1px solid",
    borderRight: "1px solid",
    borderColor: semanticColors.mainBackground,
    position: 'absolute',
    left: '50%',
    marginLeft: '-25px',
    top: '0'
  },
  item: {
    float: 'left',
    margin:'0',
    padding: '0',
    width: '50px',
    height: '100%'
  },
  overlay: {
    position: 'absolute',
    top: '2px',
    left: '0',
    width: '100%',
    height: '35px',
    background: 'linear-gradient(to right, rgba(247,247,247,1) 2%,rgba(247,247,247,1) 6%,rgba(247,247,247,0) 50%,rgba(247,247,247,1) 92%,rgba(255,255,255,1) 200%)'
  },
  active: {
    color: semanticColors.info
  }
}
  TimeWheelInput.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    maxSelectionValue: PropTypes.number,
    overLayColor: PropTypes.string,
    ulStyles: PropTypes.object
  };
export default Radium(TimeWheelInput)


// WEBPACK FOOTER //
// ./src/App/Common/timeWheelInput.jsx